import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit'

import request from '@/modules/base/util/request'
import { user } from 'ampersand-app'
import settingsConfig from '@/modules/settings/config'

export interface TenantSettingsState {
  ai: {
    enabled: boolean
  }
}

const initialState: TenantSettingsState = {
  ai: {
    enabled: true,
  },
}

export const fetchTenantUserSettings = createAsyncThunk(
  'tenantUser/settings/fetch',
  async(_) => {
    const response = await user.getTenantUserSetting()
    return response.body.data
  },
)
export const updateTenantUserSettings = createAsyncThunk(
  'tenantUser/settings/update',
  async(settings: Partial<TenantSettingsState>) => {
    const response = await request(settingsConfig.tenantUserSettings, { auth: true, method: 'PUT', data: { ...settings } })
    return response.body.data
  },
)

const settingsSlice = createSlice({
  name: 'tenantUser/settings',
  initialState,
  reducers: {
    setSettings: (state, action: PayloadAction<TenantSettingsState>) => {
      state = {
        ...state,
        ...action.payload,
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTenantUserSettings.fulfilled, (state, action) => {
        return {
          ...state,
          ...action.payload,
        }
      })
      .addCase(updateTenantUserSettings.fulfilled, (state, action) => {
        return {
          ...state,
          ...action.payload,
        }
      })
  },
})

export const {
  setSettings,
} = settingsSlice.actions

export const selectAiSettingsEnabled = (state: { tenantUser: { settings: TenantSettingsState } }) => state.tenantUser.settings.ai.enabled

export default settingsSlice.reducer
